import script from "./activity-introduce-image.vue?vue&type=script&lang=ts&setup=true"
export * from "./activity-introduce-image.vue?vue&type=script&lang=ts&setup=true"

import "./activity-introduce-image.vue?vue&type=style&index=0&id=f629641c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f629641c"]])

export default __exports__